
import { type IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import {  Box, Button, Card, Text, Title } from '@mantine/core'
import Head from 'next/head'
import Image from 'next/image'

import { Icon, } from '@flecto/ui'

import styles from './styles.module.css'

export type PageErrorProps = {
  icon: IconDefinition
  title: string
  description: string
  actionLabel: string
  actionCallback: () => void
}

export function PageError({ icon, title, description, actionLabel, actionCallback }: PageErrorProps) {
  return (
    <Box className={styles.page}>
      <Head>
        <title>{title}</title>
      </Head>
      <Card className={styles.card}>
        <Box className={styles.content}>
          <Icon
            className={styles.icon}
            icon={icon}
            size='xl'
            mb='sm'
            withCircleBackground
          />
          <Box>
            <Title fw={500} order={2}>
              {title}
            </Title>
            <Text size='lg' mt='sm' c='dimmed'>
              {description}
            </Text>
            <Button
              color='dark'
              variant='light'
              mt='xl'
              onClick={actionCallback}
            >
              {actionLabel}
            </Button>
          </Box>
        </Box>
        <Box className={styles.img}>
          <Image
            src='https://picsum.photos/700/700?random'
            alt='Random Img'
            width={1000}
            height={1000}
          />
        </Box>
      </Card>
    </Box>
  )
}
